import React, { useEffect, useState } from "react";
import { Container, Grid, Typography, useTheme, Box } from "@mui/material";
import { useParams } from "react-router-dom";
import BusinessNavbar from "../../components/business/Navbar";
import {
  getFromLocalStorage,
  saveInLocalStorage,
} from "../../config/localStorage";
import ProductCard from "../../components/business/ProductCart";
import { getCompanyBySlug } from "../../apis/company.api";
import { getProductByCompany } from "../../apis/product.api";
import LoadingWithAnimation from "../../components/loading/LoadingWithAnimation";

const BusinessScreen: React.FC = () => {
  const theme = useTheme();
  const { businessSlug } = useParams();

  //   TODO: Get business detail
  const [businessInfo, setBusinessInfo] = useState<
    Record<string, any> | undefined
  >();
  const [products, setProducts] = useState<any[]>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getProducts = async (companyId: string) => {
    return await getProductByCompany(companyId).then((res) => {
      return res;
    });
  };

  const getBusinessInfo = async (slug: string) => {
    setIsLoading(true);
    await getCompanyBySlug(slug).then(async (res) => {
      setBusinessInfo(res);
      await getProducts(res._id).then((products) => {
        setProducts(products);
      });
    });
    setIsLoading(false);
  };

  //   Check if there is a cart for this already
  useEffect(() => {
    if (businessInfo?.slug && businessInfo._id) {
      const currentCompanyCart = getFromLocalStorage(
        `cart-${businessInfo.slug}`
      );
      if (!currentCompanyCart) {
        const tempCart = {
          companySlug: businessInfo.slug,
          companyId: businessInfo._id,
          orderPlacementMethod: "ONLINE",
          items: [],
        };
        saveInLocalStorage(`cart-${businessInfo.slug}`, tempCart);
      }
    }
  }, [businessInfo?._id, businessInfo?.slug]);

  useEffect(() => {
    if (businessInfo?._id) saveInLocalStorage("bussInfo", businessInfo);
  }, [businessInfo]);

  useEffect(() => {
    if (businessSlug) getBusinessInfo(businessSlug);
  }, [businessSlug]);

  if (!businessSlug || JSON.stringify({}) === JSON.stringify(businessInfo)) {
    return <div>No business Details Available</div>;
  }

  if (isLoading) {
    return <LoadingWithAnimation open={isLoading} transparent={false} />;
  }

  return (
    <Grid
      container
      direction="column"
      sx={{
        overflowX: "hidden",
        background: theme.palette.primary.light,
        minHeight: "100vh",
      }}
    >
      {/* Header */}
      <Grid item>
        <BusinessNavbar businessInfo={businessInfo ?? {}} />
      </Grid>

      {/* Products */}
      <Grid item container flexGrow={1} sx={{ padding: theme.spacing(2) }}>
        <Container>
          <Typography
            sx={{ fontSize: 24, fontWeight: 500, letterSpacing: 1 }}
            gutterBottom
          >
            Products
          </Typography>
          <Grid container spacing={1}>
            {products?.map((product) => (
              <Grid item xs={12} sm={6} md={3} key={product._id}>
                <ProductCard
                  businessInfo={businessInfo ?? {}}
                  productId={product?._id}
                  categoryID={product?.categoryID}
                  image={product?.picture}
                  productName={product.name}
                  description={product?.description}
                  price={product?.price}
                  options={product?.options}
                  discount={product?.reduction}
                  rating={3}
                  totalQuantity={product.quantity}
                  ribbonColor={"orange"}
                  buttonColor={""}
                />
              </Grid>
            ))}
          </Grid>
        </Container>
      </Grid>

      {/* Footer */}
      <Grid item>
        <Box
          sx={{
            padding: theme.spacing(2),
            backgroundColor: theme.palette.secondary.light,
            textAlign: "center",
          }}
        >
          <Typography variant="body2">
            &copy; {new Date().getFullYear()} LETSERVU. All rights reserved.
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

export default BusinessScreen;
